export const kendoMultiSelectTagMapper = (tags: any[]): any[] => {
  if (!tags || tags.length === 0) {
    return [];
  }

  if (tags.length > 1) {
    return [tags];
  }

  return tags;
};
